module.exports = __webpack_public_path__ + "2e65ff479a621ed750454a34ca13deb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/close_active.png
// module id = 745
// module chunks = 0